"use strict";
exports.__esModule = true;
exports.EntityAddFormField = exports.EntityAddFormDocument = void 0;
var EntityAddFormDocument = /** @class */ (function () {
    function EntityAddFormDocument(org_id, entity_type, fields) {
        this.org_id = org_id;
        this.entity_type = entity_type;
        this.fields = fields;
    }
    EntityAddFormDocument.fromJSON = function (json) {
        var form = new EntityAddFormDocument('', null, []);
        if (json) {
            form.org_id = json.org_id ? json.org_id : '';
            form.entity_type = json.entity_type ? json.entity_type : null;
            form.fields = json.fields ? json.fields.map(function (field) { return EntityAddFormField.fromJSON(field); }) : [];
        }
        return form;
    };
    return EntityAddFormDocument;
}());
exports.EntityAddFormDocument = EntityAddFormDocument;
var EntityAddFormField = /** @class */ (function () {
    function EntityAddFormField(position, field_name, required, is_editable) {
        if (required === void 0) { required = false; }
        if (is_editable === void 0) { is_editable = true; }
        this.position = position;
        this.field_name = field_name;
        this.required = required;
        this.is_editable = is_editable;
    }
    EntityAddFormField.fromJSON = function (json) {
        var field = new EntityAddFormField(0, '', false, true);
        if (json) {
            field.position = json.position ? json.position : 0;
            field.field_name = json.field_name ? json.field_name : '';
            field.required = json.required !== undefined ? json.required : false;
            field.is_editable = json.is_editable !== undefined ? json.is_editable : true;
        }
        return field;
    };
    return EntityAddFormField;
}());
exports.EntityAddFormField = EntityAddFormField;
